import React, { Fragment } from 'react';
import { useTranslate, Show, TextField, DateField } from 'react-admin';
import { LinkField } from 'cw-core-admin-ui/src/components/fields';
import { Grid, GridShowLayout } from 'cw-core-admin-ui/src/components/wrapper';
import MarketplaceShowActions from './MarketplaceShowActions';
import MarketplaceAuthenticationList from './authentications/MarketplaceAuthenticationList';
import { Typography } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
	titles: {
		marginTop: 10,
		marginBottom: 20,
	},
	show: {
		marginBottom: 24,
	},
});

export default (props) => {
	const translate = useTranslate();
	const classes = useStyles(props);
	return (
		<Fragment>
			<Show {...props} actions={<MarketplaceShowActions />} className={classes.show}>
				<GridShowLayout>
					<Grid container spacing={2}>
						<Grid item xs={12} md>
							<TextField source="id" />
							<DateField source="creationDateTime" showTime />
							<TextField source="status" />
							<TextField source="name" />
						</Grid>
						<Grid item xs={12} md>
							<LinkField source="walletId" type="Wallet" />
						</Grid>
					</Grid>
				</GridShowLayout>
			</Show>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.marketplaces.fields.authorizations')}
			</Typography>
			<MarketplaceAuthenticationList basePath={'/marketplaceAuthentications'} resource={'marketplaceAuthentications'} perPage={5} filter={{ marketplaceId: props.id }}></MarketplaceAuthenticationList>
		</Fragment>
	);
};
